import type { TOC } from '@ember/component/template-only';
import { PrismViewSwitcher } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import SettingsCentralMappingMenuBreakdownCard from 'lumen/components/settings/central-mapping/menu/breakdown-card';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsCentralMappingMenuController from 'lumen/controllers/hotel/settings/central-mapping/menu';
import { CENTRAL_MAPPING_MENU_VIEWS } from 'lumen/controllers/hotel/settings/central-mapping/menu';

interface HotelSettingsCentralMappingMenuSignature {
  Args: {
    controller: HotelSettingsCentralMappingMenuController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.central_mapping.subheader"}}
    @hasAccountSelector={{true}}
    @title={{t "settings.central-mapping.mapping"}}
    class="central-mapping"
  >
    <:link>
      <GeneralNavigationIntercomHelpLink
        @articleLink={{@controller.menuHelpCenterLink}}
        @iconName="link-out"
        @linkText={{t "general.learn_more"}}
        @type="text-and-icon"
      />
    </:link>
    <:default>
      {{#if @controller.access.hasBenchmarkInsightMappingTab}}
        <div
          class="central-mapping__view-switcher mb-600"
          data-test-id="central-mapping-menu-view-switcher"
        >
          <PrismViewSwitcher
            @activeButtonId={{@controller.view}}
            @onSetActiveButtonId={{@controller.setView}}
            as |ViewSwitcher|
          >
            <ViewSwitcher.button
              @id={{CENTRAL_MAPPING_MENU_VIEWS.BI}}
              @label={{t "general.bi"}}
            />

            <ViewSwitcher.button
              @id={{CENTRAL_MAPPING_MENU_VIEWS.BENCHMARK}}
              @label={{t "demand.benchmark"}}
            />
          </PrismViewSwitcher>
        </div>
      {{/if}}

      <div class="central-mapping__menu" data-test-id="central-mapping-menu">
        {{#if (eq @controller.view CENTRAL_MAPPING_MENU_VIEWS.BI)}}
          {{#each @controller.centralMapping.sortedBreakdownsBi as |breakdown|}}
            <SettingsCentralMappingMenuBreakdownCard
              @breakdown={{breakdown}}
              @hierarchyRoute={{@controller.hierarchyRoute}}
              @mappingRoute={{@controller.mappingRoute}}
            />
          {{/each}}
        {{else}}
          {{#each
            @controller.centralMapping.sortedBreakdownsBenchmark
            as |breakdown|
          }}
            <SettingsCentralMappingMenuBreakdownCard
              @breakdown={{breakdown}}
              @hierarchyRoute={{@controller.hierarchyRoute}}
              @mappingRoute={{@controller.mappingRoute}}
            />
          {{/each}}
        {{/if}}
      </div>
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsCentralMappingMenuSignature>;
